import { createContext, useContext } from 'react'
import type { GuestProfile } from '../api/types'
import type { QueueView } from '../upload/useUploadQueue'

/**
 * Wat de schil van het album al opgehaald heeft en de pagina's erbinnen nodig
 * hebben. De wachtrij zit erin zodat de galerij, de challenges en het
 * uploadstatus-paneel naar één en dezelfde kijken.
 */
export interface Album {
  queue: QueueView

  /**
   * Opent of sluit een paneel via de querystring. Null sluit.
   *
   * `challengeId` koppelt wat je daarna uploadt aan die challenge — zo komt
   * scherm 22E met één knop bij dezelfde uploadflow uit als de galerij.
   */
  openPanel: (panel: string | null, challengeId?: string | null) => void

  profile: GuestProfile | undefined

  /**
   * Meekijken zonder mee te doen.
   *
   * Staat aan als de eigenaar een privé galerij bekijkt. Er is
   * dan geen gast — hij heeft nooit een naam opgegeven — dus er valt niets te
   * uploaden, te hernoemen of te verwijderen. De server houdt dat sowieso
   * tegen; dit zorgt dat het scherm niets aanbiedt wat toch niet lukt.
   */
  readOnly: boolean
}

export const AlbumContext = createContext<Album | null>(null)

export function useAlbum(): Album {
  const album = useContext(AlbumContext)

  if (!album) {
    throw new Error('useAlbum hoort binnen de <AlbumLayout>.')
  }

  return album
}
